import { getRoomPanelViewState } from './getRoomPanelViewState';

export default function getPlaceholderRoomLists(viewStateId: string | null) {
    const { defaultRoomList } = getRoomPanelViewState(viewStateId).roomListViewState;
    return defaultRoomList.email ? [defaultRoomList] : [];
}
